export default "__VITE_ASSET__DdT0gg7l__"